var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('i-input',{attrs:{"size":"small","icon":_vm.icon,"placeholder":_vm.placeholder},on:{"on-click":_vm.handleClick},model:{value:(_vm.currentQuery),callback:function ($$v) {_vm.currentQuery=$$v},expression:"currentQuery"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-782ad6e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/components/commonComponents/transfer/search.vue
// module id = null
// module chunks = 